<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="4" :sm="12">
            <a-form-item label="月份">
              <a-select placeholder="请选择" v-model="queryParam.month">
                <a-select-option value="01">1月</a-select-option>
                <a-select-option value="02">2月</a-select-option>
                <a-select-option value="03">3月</a-select-option>
                <a-select-option value="04">4月</a-select-option>
                <a-select-option value="05">5月</a-select-option>
                <a-select-option value="06">6月</a-select-option>
                <a-select-option value="07">7月</a-select-option>
                <a-select-option value="08">8月</a-select-option>
                <a-select-option value="09">9月</a-select-option>
                <a-select-option value="10">10月</a-select-option>
                <a-select-option value="11">11月</a-select-option>
                <a-select-option value="12">12月</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="10">
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;height:40px;">
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="itemSlot" slot-scope="item">
          <span v-if="item.level===1">{{item.text}}</span>
          <span v-if="item.level===2" style="margin-left:0px;">{{item.text}}</span>
          <span v-if="item.level===3" style="margin-left:45px;">{{item.text}}</span>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '@/api/manage'
  import {getDictItemsFromCache} from '@/api/api'
  import { toDecimal } from '@/utils/util'

  export default {
    name: 'BizHeadquartersLifeReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '总部寿险报表', // 长期寿险项目
        disableMixinCreated: true,
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目',
            className: 'column-text',
            scopedSlots: {customRender: 'itemSlot'}
          },
          {
            title:'保费',
            className: 'column-money',
            dataIndex: 'cleanPremium'
          },
          {
            title:'佣金',
            className: 'column-money',
            dataIndex: 'invoiceAmount'
          },
        ],
        url: {
          list: "/bms/regulatoryReport/headquartersLifeReport",
        },
      }
    },
    created() {
    },
    methods: {
      searchQuery(){
        if(this.queryParam.month){
          this.loadData()
        }
      },
      loadData() {
        this.loading = true;

        let year = new Date().getFullYear()
        let param = {year: year, month: this.queryParam.month}

        /*以invoice_time字段进行比较，即财务开票日期归属到不同月份*/
        postAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = this.transferData(res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      // 把后台返回数据进行格式转换
      transferData(resultData){
        if(!resultData){
          return;
        }

        //处理两个特殊编码 投连年金 万能年金
        let moneyTLNJSX = this.getMoney(resultData, '41');
        let moneyTLSX = this.getMoney(resultData, '24');
        if(moneyTLNJSX != null){
          if(moneyTLSX == null){
            moneyTLSX = {insuranceCode:'24', cleanPremium: moneyTLNJSX['cleanPremium'], invoiceAmount: moneyTLNJSX['invoiceAmount']}
            resultData.push(moneyTLSX)
          } else {
            moneyTLSX['cleanPremium'] = moneyTLSX['cleanPremium'] + moneyTLNJSX['cleanPremium']
            moneyTLSX['invoiceAmount'] = moneyTLSX['invoiceAmount'] + moneyTLNJSX['invoiceAmount']
          }
        }

        let moneyWNNJSX = this.getMoney(resultData, '42');
        let moneyWNSX = this.getMoney(resultData, '25');
        if(moneyWNNJSX != null){
          if(moneyWNSX == null){
            moneyWNSX = {insuranceCode:'25', cleanPremium: moneyWNNJSX['cleanPremium'], invoiceAmount: moneyWNNJSX['invoiceAmount']}
            resultData.push(moneyWNSX)
          } else {
            moneyWNSX['cleanPremium'] = moneyWNSX['cleanPremium'] + moneyWNNJSX['cleanPremium']
            moneyWNSX['invoiceAmount'] = moneyWNSX['invoiceAmount'] + moneyWNNJSX['invoiceAmount']
          }
        }

        // 总部寿险数据，顺序是确定的, level是报表中的级次，显示用
        let zbLifeData = [{text:'一、寿险小计',level:1, insuranceTypeCode:'SXXJ', cleanPremium:890.00, invoiceAmount:0.00},{text:'（一）普通寿险',level:2, insuranceTypeCode:'PTSX', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'1、定期寿险',level:3, insuranceTypeCode:'33', cleanPremium:0.00, invoiceAmount:0.00},{text:'2、两全寿险',level:3, insuranceTypeCode:'34', cleanPremium:0.00, invoiceAmount:0.00},{text:'3、终身寿险',level:3, insuranceTypeCode:'35', cleanPremium:0.00, invoiceAmount:0.00},{text:'4、年金保险',level:3, insuranceTypeCode:'36', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'（二）分红寿险',level:2, insuranceTypeCode:'FHSX', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'1、定期寿险',level:3, insuranceTypeCode:'37', cleanPremium:0.00, invoiceAmount:0.00},{text:'2、两全寿险',level:3, insuranceTypeCode:'38', cleanPremium:0.00, invoiceAmount:0.00},{text:'3、终身寿险',level:3, insuranceTypeCode:'39', cleanPremium:0.00, invoiceAmount:0.00},{text:'4、年金保险',level:3, insuranceTypeCode:'40', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'（三）投资连结产品',level:2, insuranceTypeCode:'24', cleanPremium:0.00, invoiceAmount:0.00},{text:'其中：年金保险',level:3, insuranceTypeCode:'41', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'（四）万能寿险',level:2, insuranceTypeCode:'25', cleanPremium:0.00, invoiceAmount:0.00},{text:'其中：年金保险',level:3, insuranceTypeCode:'42', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'二、意外伤害险小计',level:1, insuranceTypeCode:'YWSH', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'1、一年期以内业务',level:3, insuranceTypeCode:'26', cleanPremium:0.00, invoiceAmount:0.00},{text:'2、一年期业务',level:3, insuranceTypeCode:'27', cleanPremium:0.00, invoiceAmount:0.00},{text:'3、一年期以上业务',level:3, insuranceTypeCode:'28', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'三、健康险小计',level:1, insuranceTypeCode:'JKX', cleanPremium:0.00, invoiceAmount:0.00},{text:'1、短期健康险',level:3, insuranceTypeCode:'29', cleanPremium:0.00, invoiceAmount:0.00},{text:'2、长期健康险',level:3, insuranceTypeCode:'30', cleanPremium:0.00, invoiceAmount:0.00},
          {text:'四、其他',level:1, insuranceTypeCode:'23', cleanPremium:0.00, invoiceAmount:0.00},{text:'总计',level:1, insuranceTypeCode:'ZJ', cleanPremium:0.00, invoiceAmount:0.00}];

        // 赋值结果集
        for(let i=0; i<zbLifeData.length; i++){
          let money = this.getMoney(resultData, zbLifeData[i].insuranceTypeCode)
          if(money){
            zbLifeData[i].cleanPremium = toDecimal(money.cleanPremium)
            zbLifeData[i].invoiceAmount = toDecimal(money.invoiceAmount)
          }
        }

        //计算求和, 根据报表公司直接求和
        //2＝3+4+5+6
        zbLifeData[1].cleanPremium = toDecimal(zbLifeData[2].cleanPremium + zbLifeData[3].cleanPremium + zbLifeData[4].cleanPremium + zbLifeData[5].cleanPremium)
        zbLifeData[1].invoiceAmount = toDecimal(zbLifeData[2].invoiceAmount + zbLifeData[3].invoiceAmount + zbLifeData[4].invoiceAmount + zbLifeData[5].invoiceAmount)
        //7＝8+9+10+11
        zbLifeData[6].cleanPremium = toDecimal(zbLifeData[7].cleanPremium + zbLifeData[8].cleanPremium + zbLifeData[9].cleanPremium + zbLifeData[10].cleanPremium)
        zbLifeData[6].invoiceAmount = toDecimal(zbLifeData[7].invoiceAmount + zbLifeData[8].invoiceAmount + zbLifeData[9].invoiceAmount + zbLifeData[10].invoiceAmount)
        //1＝2+7+12+14
        zbLifeData[0].cleanPremium = toDecimal(zbLifeData[1].cleanPremium + zbLifeData[6].cleanPremium + zbLifeData[11].cleanPremium + zbLifeData[13].cleanPremium)
        zbLifeData[0].invoiceAmount = toDecimal(zbLifeData[1].invoiceAmount + zbLifeData[6].invoiceAmount + zbLifeData[11].invoiceAmount + zbLifeData[13].invoiceAmount)
        //16＝17+18+19
        zbLifeData[15].cleanPremium = toDecimal(zbLifeData[16].cleanPremium + zbLifeData[17].cleanPremium + zbLifeData[18].cleanPremium)
        zbLifeData[15].invoiceAmount = toDecimal(zbLifeData[16].invoiceAmount + zbLifeData[17].invoiceAmount + zbLifeData[18].invoiceAmount)
        //20＝21+22
        zbLifeData[19].cleanPremium = toDecimal(zbLifeData[20].cleanPremium + zbLifeData[21].cleanPremium)
        zbLifeData[19].invoiceAmount = toDecimal(zbLifeData[20].invoiceAmount + zbLifeData[21].invoiceAmount)
        //24＝1+16+20+23
        zbLifeData[23].cleanPremium = toDecimal(zbLifeData[0].cleanPremium + zbLifeData[15].cleanPremium + zbLifeData[19].cleanPremium + zbLifeData[22].cleanPremium)
        zbLifeData[23].invoiceAmount = toDecimal(zbLifeData[0].invoiceAmount + zbLifeData[15].invoiceAmount + zbLifeData[19].invoiceAmount + zbLifeData[22].invoiceAmount)

        return zbLifeData;
      },

      getMoney(resultData, code){
        for(let i=0; i<resultData.length; i++){
          if(resultData[i].insuranceTypeCode == code){
            return resultData[i];
          }
        }
        //没有找到返回null
        return null;
      },


      /*getZBLifeData(zbLifeData, resultData, index){
        let data = resultData[zbLifeData.code];
        let YWJBF = 0.0, YWJYJ = 0.0, YWDZJYJ=0.0, ZTJBF = 0.0, ZTJYJ = 0.0, ZTDZJYJ=0.0

        if(data['cleanPrenium']){ // 保费
          YWJBF = data['cleanPremium']
        }
        if(data['invoiceAmount']){ // 佣金
          ZTJBF = data['invoiceAmount']
        }

        return {}
      },*/
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>
